import { css, keyframes } from '@emotion/react';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const makeFormElementStyles = ({ theme, isVisible, isProgressiveReveal }) => {
  return {
    component: css({
      display: isVisible ? 'block' : 'none',
      ...(isProgressiveReveal && {
        animation: `${fadeIn} 450ms ease-in`,
      }),
    }),
    maxWidthWrapper: css({
      [theme.breakpoints.up('md')]: {
        maxWidth: theme.breakpoints.values.md,
        marginLeft: 'auto',
        marginRight: 'auto',
      },
    }),
  };
};

export default makeFormElementStyles;
